"use client"

import type { ComponentProps, ReactNode } from "react"

import { useRouter } from "next/navigation"
import toast from "react-hot-toast"

import { loginDto } from "#app/(frontend)/[locale]/(user)/(auth)/login/login.dto"
import { RHFForm } from "#components/form/rhfFormContext"
import { useValidatedForm } from "#components/form/useValidatedForm"
import { useTranslation } from "#modules/localization/translations.client"
import { authService } from "#services/user/authService"

export function LoginForm({ children, ...restFormProps }: { children: ReactNode } & Omit<ComponentProps<typeof RHFForm>, "formMethods" | "children" | "validationSchema">) {
  const { t } = useTranslation("forms", "page/login")

  const router = useRouter()

  const formMethods = useValidatedForm({
    validation: loginDto(t),
    onSubmit: async data => {
      toast.loading(t("page/login:processing.loginLoading"))

      try {
        await authService.loginStrapiUser(data)

        toast.dismiss()
        toast.success(t("page/login:processing.loginSuccess"))

        formMethods.reset()
        router.replace("/account/profile")
        router.refresh()
      } catch (e) {
        // TODO rausfinden ob man Anmeldung wegen Eingabedaten und Anmeldung wegen noch nicht bestätigter Email-Adresse sauberer anhand der Response trennen kann
        toast.dismiss()
        toast.error(t("page/login:processing.loginError"))
        formMethods.resetField("password")
      }
    },
  })

  return (
    <RHFForm {...restFormProps} formMethods={formMethods}>
      {children}
    </RHFForm>
  )
}
